import React from 'react';
import {Container, Row, Col } from 'react-bootstrap';

const Footer = ()=>{

	const dattime = new Date();
	
	return(
		<Container fluid className="footer-wrapper">
			<Row className="footer">
				<Col xs={12} >
					 Creative Create LLC. Long Beach, CA. (562)-774-1828 | info@creativecreate.com
					 <br/>
					© Copyright {dattime.getFullYear()} Creative Create LLC.
				</Col>
			</Row>
		</Container>
	)
}

export default Footer;